import React from 'react';
import {NavLink, useLocation, useNavigate} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import MarchioNova from './MarchioNova';
import SpiaRiproposte from '../Header/SpiaRiproposte';
import Busta from '../Header/Busta';
import {ricerca, schedeCasino, sezioniAccese, testata} from '../../moduli/leggi';
import {eColore} from '../../skin';
import {getCurrentUsername, isPlayer} from '../../utils/currentUser';
import {haLaVoce, haUnaVoce} from '../../utils/permessi';
import {avanzamentoBonus, cifra, importo} from '../../utils/conto';
import BarraBonus from '../BarraBonus';
import {LivelloInTestata} from '../Pagine/Fedelta';
import IconaNova, {ICONA_AIUTO} from './IconaNova';
import {pagineAiutoAccese, pagineDelMenuAccese, vociColonnaConto, vociDellaRete} from './voci';
import {lingua, lingueDisponibili, impostaLingua} from '../../preferenze';
import Bandiera from '../common/Bandiera';
import {paeseDellaLingua} from '../Header/testata/bandierine';

/* Nella testata Casinò viene prima di Live casino (nel catalogo è dopo); le altre restano dove sono. */
function casinoPrima(sezioni) {
  const c = sezioni.findIndex((s) => s.chiave === 'casino');
  const l = sezioni.findIndex((s) => s.chiave === 'liveCasino');
  if (c < 0 || l < 0 || c < l) return sezioni;
  const fuori = sezioni.filter((s) => s.chiave !== 'casino');
  fuori.splice(l, 0, sezioni[c]);
  return fuori;
}

/**
 * LA TESTATA NOVA: logo, le sezioni accese come interruttore, e a destra
 * Accedi e Registrati oppure, per chi e' dentro, Deposita, il saldo ed Esci.
 * Fissa in alto.
 *
 * ESCI E' QUI, NON NEL MENU, dal computer in su: in alto a destra e' dove lo
 * si cerca.
 *
 * SUL TELEFONO E SUL TABLET (sotto i 1024px, dove c'e' la barra in basso) la
 * testata e' come quella del computer, ma non ripete la barra: niente
 * hamburger e niente menu a sinistra. Sulla prima riga il logo col nome, e a
 * destra da ospite Aiuto e la lingua (Accedi e Registrati sono in basso), da
 * dentro il saldo con l'occhio e Aiuto (Deposita e' «Versa» in basso, il
 * conto ed Esci sono in «Conto»). Sotto, la seconda riga (RigaTelefono): le
 * sezioni accese in maiuscolo (CASINÒ, LIVE CASINO, CRASH GAME…), lastre in
 * rilievo con la riga d'oro sotto quella aperta come dal computer. Le pagine
 * in piu' stanno in «Altro» e «Cerca» nel pannello Giochi della barra in basso.
 *
 * IL SALDO E' CENSURATO finche' non si tocca l'occhio alla sua sinistra: chi guarda lo
 * schermo da dietro le spalle non lo legge. L'occhio aperto mostra anche il
 * nome utente, sopra la cifra; chiuso, al suo posto torna «Saldo». La scelta non si ricorda: a ogni
 * accesso (e a ogni pagina ricaricata) riparte nascosto. La tiene il guscio,
 * perche' i pannelli del telefono mostrano lo stesso saldo con lo stesso occhio.
 *
 * I pezzi sono quelli del sito, solo disposti come in Nova: il logo e le
 * sezioni arrivano dalla skin, il saldo dal conto (se il servizio non lo
 * manda non compare), Accedi apre la finestra di accesso di sempre, e
 * Registrati porta alla pagina di registrazione.
 *
 * DAL COMPUTER, COL MENU IN TESTATA (modulo Testata › Menu, di serie;
 * `orizzontale`): non c'e' la colonna a sinistra, e la riga in alto e' il
 * menu: il logo, poi le sezioni accese una accanto all'altra (Casino', Live
 * casino, Sport…), solo da cliccare: le categorie stanno nella pagina della
 * sezione (la tendina con le schede torna col modulo Testata › Categorie in
 * tendina), poi «Altro» con le pagine di Aiuto e, per chi
 * e' dentro, le voci del conto e Gioco responsabile: le stesse voci del menu
 * a colonna (voci.js), cosi' niente si perde togliendo la colonna. Le tendine
 * si aprono al passaggio del mouse e al clic (per chi non ha il mouse), e si
 * chiudono cambiando pagina. Registrati e' d'oro, Accedi a contorno.
 *
 * COL MENU A COLONNA il logo sta sopra il menu, da solo: la sua casella e'
 * larga quanto il menu, con la stessa riga a destra, e le sezioni partono
 * sopra la pagina come interruttore. Nome e simbolo del logo li decide il
 * modulo Testata (MarchioNova).
 *
 * LA CASELLA «CERCA GIOCHI» sta qui, in alto a destra, prima di Accedi e
 * Registrati o, per chi e' dentro, prima di Deposita: con Invio apre la
 * pagina dei risultati (/cerca?q=…). La comanda il modulo Ricerca giochi
 * (accesa, la scritta dentro). Sul telefono in testata non c'e' posto: li'
 * si cerca dalla pagina dei risultati, che si apre da «Cerca giochi» nel
 * menu. Col menu in testata la casella non c'e' (vedi sotto). «Deposita» porta alla Cassa
 * del conto, e c'e' solo per chi ha la voce SITE_DEPOSIT nel gettone
 * (utils/permessi.js); il saldo porta alla Cassa chi puo' versare o
 * prelevare, gli altri al conto.
 *
 * COL MENU IN TESTATA, A DESTRA (da destra verso sinistra): Esci, Account,
 * il saldo, Deposita, Aiuto; da ospite Registrati, Accedi, Aiuto. «Aiuto»
 * (le pagine di Aiuto accese) prende il posto della casella «Cerca giochi»,
 * che qui non c'e': si cerca dalla home e dalle lobby. «Account» apre il
 * conto (le voci di voci.js e Gioco responsabile). Cosi' «Altro» tiene solo
 * le pagine in piu' del modulo Pagine. Fra 1024 e 1280px Aiuto e Account
 * restano solo icona. Esci e' d'oro come Deposita, Account ha il bordo al
 * neon nel colore della skin, e ogni tasto a destra si illumina al
 * passaggio del mouse (Nova.css).
 */
export default function TestataNova({userService, dentro, conto, orizzontale, onAccedi, onEsci, saldoVisibile, onOcchio}) {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const sezioni = casinoPrima(sezioniAccese());
  const nome = (userService && typeof userService.getUsername === 'function' && userService.getUsername())
    || getCurrentUsername() || '';
  /* La cifra da mostrare: il saldo per chi gioca, la disponibilita' per chi
     amministra (come la striscia di sempre). */
  const principale = isPlayer() ? 'userBalance' : 'available';
  const saldo = cifra(conto, principale);
  /* Il saldo bonus (utils/conto.js, conBonus) sotto il saldo vero, con lo
     stesso occhio: c'e' solo per chi gioca e solo se non e' zero. */
  const bonus = cifra(conto, 'bonusBalance');
  /* Col menu in testata al posto della casella c'e' «Aiuto». */
  const cercaGiochi = orizzontale ? {casella: false} : ricerca();
  const posizione = useLocation();
  /* Sulla pagina dei risultati la casella riparte da quello che si e' cercato. */
  const cercato = posizione.pathname === '/cerca' ? (new URLSearchParams(posizione.search).get('q') || '') : '';
  const [scritto, setScritto] = React.useState(cercato);
  React.useEffect(() => { setScritto(cercato); }, [cercato]);
  const cerca = (e) => {
    e.preventDefault();
    const q = scritto.trim();
    navigate(q ? '/cerca?q=' + encodeURIComponent(q) : '/cerca');
  };
  /* I colori propri del modulo Testata, come nella striscia di sempre. */
  const colori = testata().colori;
  const stile = {};
  if (colori && eColore(colori.fondo)) stile['--lvc-nav-1'] = colori.fondo.trim();
  if (colori && eColore(colori.testo)) stile['--n-text'] = colori.testo.trim();

  return (
    <header className={'nova-testata'} style={stile}>
      <NavLink to={'/'} className={'nova-logo'} aria-label={t('Home')}><MarchioNova/></NavLink>

      {/* L'interruttore delle sezioni: sul tablet sempre; dal computer solo col menu a colonna (Nova.css). */}
      {sezioni.length > 0 && (
        <nav className={'nova-switch'} aria-label={t('Sezioni')}>
          {sezioni.map((s) => (
            <NavLink key={s.chiave} to={s.percorso} className={({isActive}) => 'nova-sw' + (isActive ? ' active' : '')}>
              {t(s.nome)}
            </NavLink>
          ))}
        </nav>
      )}
      {orizzontale && <MenuInTestata sezioni={sezioni}/>}

      <div className={'nova-destra'}>
        {/* Aiuto: dal computer solo col menu in testata (col menu a colonna sta nel menu); sul telefono sempre. */}
        <AiutoInTestata classe={orizzontale ? '' : 'nova-solo-telefono'}/>
        {cercaGiochi.casella && (
          <form className={'nova-cerca-testata'} role={'search'} onSubmit={cerca}>
            <button type={'submit'} className={'nova-lente'} aria-label={t('Cerca')}>
              <Lente/>
            </button>
            <input type={'search'} value={scritto} onChange={(e) => setScritto(e.target.value)}
              placeholder={cercaGiochi.segnaposto || t('Cerca giochi')} aria-label={cercaGiochi.segnaposto || t('Cerca giochi')}/>
          </form>
        )}
        {!dentro ? (
          <>
            <button type={'button'} className={'nova-btn ghost nova-solo-computer'} onClick={onAccedi}>{t('Accedi')}</button>
            <button type={'button'} className={'nova-btn primary nova-solo-computer'} onClick={() => navigate('/register')}>{t('Registrati')}</button>
            {/* La lingua: dal computer solo col menu in testata; sul telefono, da ospite, accanto ad Aiuto. */}
            <LinguaInTestata classe={orizzontale ? '' : 'nova-solo-telefono'}/>
          </>
        ) : (
          <>
            <SpiaRiproposte dentro={dentro} navigate={navigate}/>
            {/* Il livello del programma fedelta' (Pagine/Fedelta.js): dal computer, accanto al saldo. */}
            <LivelloInTestata classe={'nova-solo-computer'}/>
            {haLaVoce('SITE_DEPOSIT') && (
              <button type={'button'} className={'nova-btn gold nova-dep nova-solo-computer'} onClick={() => navigate('/my-account/cassa')}>
                <span className={'nova-piu'}>+</span><span className={'nova-lbl'}>{t('Deposita')}</span>
              </button>
            )}
            {saldo !== null && (
              <div className={'nova-saldo-gruppo'}>
                <button type={'button'} className={'nova-occhio'} aria-pressed={saldoVisibile}
                  aria-label={saldoVisibile ? t('Nascondi il saldo') : t('Mostra il saldo')}
                  title={saldoVisibile ? t('Nascondi il saldo') : t('Mostra il saldo')}
                  onClick={onOcchio}>
                  <Occhio aperto={saldoVisibile}/>
                </button>
                <button type={'button'} className={'nova-saldo'}
                  onClick={() => navigate(haUnaVoce(['SITE_DEPOSIT', 'SITE_WITHDRAW']) ? '/my-account/cassa' : '/my-account')}>
                  <small>{saldoVisibile && nome ? nome : (isPlayer() ? t('Saldo') : t('Disp.'))}</small>
                  <b className={saldoVisibile ? undefined : 'censurato'}>
                    {saldoVisibile ? importo(saldo, conto && conto.currency) : '••••••'}
                  </b>
                  {bonus !== null && (
                    <em className={'nova-saldo-bonus'} title={t('Saldo bonus, non prelevabile')}>
                      {t('Bonus')} {saldoVisibile ? importo(bonus, conto && conto.currency) : '•••'}
                      {saldoVisibile && <BarraBonus avanzamento={avanzamentoBonus(conto)}/>}
                    </em>
                  )}
                </button>
              </div>
            )}
            {/* La busta dei messaggi accanto al saldo, su computer e su telefono. */}
            <Busta dentro={dentro} classe={'nova-busta'}/>
            {orizzontale && <AccountInTestata nome={nome}/>}
            <button type={'button'} className={'nova-btn gold nova-esci'} onClick={onEsci}>
              {orizzontale && <IconaNova nome={'esci'} misura={16}/>}{t('Esci')}
            </button>
            {orizzontale && <LinguaInTestata classe={'nova-solo-computer'}/>}
          </>
        )}
      </div>
      <RigaTelefono sezioni={sezioni}/>
    </header>
  );
}

/**
 * IL MENU IN TESTATA (dal computer, modulo Testata › Menu = «In testata»):
 * le sezioni accese, con le schede in tendina, e «Altro» con le pagine in piu'
 * (Aiuto e il conto hanno i loro tasti a destra).
 * Si vede solo dal computer in su (Nova.css, `.nova-nav`).
 */
function MenuInTestata({sezioni}) {
  const {t} = useTranslation();
  const posizione = useLocation();
  const schedaScelta = new URLSearchParams(posizione.search).get('scheda');
  const categoriaScelta = new URLSearchParams(posizione.search).get('categoria');
  /* Le pagine del modulo Pagine: Promozioni e Tornei in alto fra le sezioni, le altre (VIP, fedelta', ruota, Hall of Fame) sotto «Altro». */
  const pagine = pagineDelMenuAccese(t);
  const inAlto = pagine.filter((p) => p.inTestata);
  const inAltro = pagine.filter((p) => !p.inTestata);
  /* «Altro» c'e' solo se dentro ha qualcosa: le pagine in piu'. */
  const altro = inAltro.length > 0;
  if (!sezioni.length && !inAlto.length && !altro) return null;
  const voce = voceTendina;
  return (
    <nav className={'nova-nav'} aria-label={t('Menu')}>
      {sezioni.map((s) => {
        /* Di serie Casino' e Live casino sono solo collegamenti: le categorie
           stanno nella loro pagina. La tendina torna col modulo Testata ›
           Categorie in tendina. */
        const schede = testata().schedeInTendina ? schedeCasino(s.chiave) : [];
        const qui = posizione.pathname === s.percorso;
        const capo = (
          <NavLink to={s.percorso} className={({isActive}) => 'nova-nav-voce' + (isActive ? ' active' : '')}>
            {t(s.nome)}
          </NavLink>
        );
        if (!schede.length) return <React.Fragment key={s.chiave}>{capo}</React.Fragment>;
        return (
          <TendinaTestata key={s.chiave} capo={capo} nome={t(s.nome)}>
            {voce(s.percorso, t('Tutti i giochi'), qui && !schedaScelta && !categoriaScelta, 'tutti')}
            {schede.map((x) => voce(s.percorso + '?scheda=' + encodeURIComponent(x.id),
                (x.icona ? x.icona + ' ' : '') + x.nome, qui && schedaScelta === x.id, 'scheda-' + x.id))}
          </TendinaTestata>
        );
      })}
      {inAlto.map((p) => (
        <NavLink key={p.chiave} to={p.percorso} className={({isActive}) => 'nova-nav-voce' + (isActive ? ' active' : '')}>
          {p.titolo}
        </NavLink>
      ))}
      {altro && (
        <TendinaTestata nome={t('Altro')}>
          <p className={'nova-nav-etichetta'}>{t('Per te')}</p>
          {inAltro.map((p) => voceTendina(p.percorso, (p.icona ? p.icona + ' ' : '') + p.titolo))}
        </TendinaTestata>
      )}
    </nav>
  );
}

/**
 * LA SECONDA RIGA DELLA TESTATA, SUL TELEFONO E SUL TABLET (sotto i 1024px;
 * dal computer non c'e', Nova.css): al posto del menu a sinistra, come le
 * voci in alto del computer. Solo le sezioni accese (Casino' prima di Live
 * casino), scritte in maiuscolo dal CSS: le pagine del modulo Pagine
 * (Promozioni, Tornei…) stanno nel pannello «Altro» della barra in basso.
 * Ogni voce e' una lastra in rilievo; quella aperta e' tinta, con la riga
 * d'oro sotto. Poche voci si dividono la riga; tante scorrono col dito, e
 * cambiando pagina la riga porta in vista quella aperta. Senza sezioni non
 * c'e', e la testata resta di una riga.
 */
function RigaTelefono({sezioni}) {
  const {t} = useTranslation();
  const {pathname} = useLocation();
  const riga = React.useRef(null);
  const voci = sezioni.map((s) => ({chiave: s.chiave, percorso: s.percorso, nome: t(s.nome)}));
  /* La voce aperta in vista, scorrendo solo la riga: scrollIntoView muoverebbe anche la pagina. */
  React.useEffect(() => {
    const el = riga.current;
    const accesa = el && el.querySelector('.active');
    if (!accesa || el.scrollWidth <= el.clientWidth) return;
    el.scrollLeft = accesa.offsetLeft - (el.clientWidth - accesa.offsetWidth) / 2;
  }, [pathname]);
  if (!voci.length) return null;
  return (
    <nav className={'nova-sezioni'} ref={riga} aria-label={t('Sezioni del telefono')}>
      {voci.map((v) => (
        <NavLink key={v.chiave} to={v.percorso} className={({isActive}) => 'nova-sezioni-voce' + (isActive ? ' active' : '')}>
          {v.nome}
        </NavLink>
      ))}
    </nav>
  );
}

/** Una voce dentro una tendina della testata; `attiva` decide al posto del percorso, `oro` la scrive d'oro (la Cassa). */
function voceTendina(to, testo, attiva, chiave, oro) {
  return (
    <NavLink key={chiave || to} to={to}
      className={({isActive}) => 'nova-nav-sotto' + (oro ? ' oro' : '') + ((attiva === undefined ? isActive : attiva) ? ' active' : '')}>
      {testo}
    </NavLink>
  );
}

/**
 * «Aiuto» a destra in testata: le pagine di Aiuto accese in tendina (al
 * passaggio del mouse) e, cliccato, porta dritto alle pagine di Aiuto con
 * la colonna a sinistra: su Assistenza, o sulla prima pagina accesa se
 * Assistenza e' spenta. Resta acceso su tutte le pagine del gruppo. Senza
 * pagine accese non c'e'.
 */
function AiutoInTestata({classe}) {
  const {t} = useTranslation();
  const {pathname} = useLocation();
  const aiuto = pagineAiutoAccese(t);
  if (!aiuto.length) return null;
  const prima = aiuto.find((p) => p.chiave === 'assistenza') || aiuto[0];
  return (
    <TendinaTestata nome={t('Aiuto')} classe={'nova-aiuto' + (classe ? ' ' + classe : '')}
      vaiA={prima.percorso} acceso={aiuto.some((p) => p.percorso === pathname)}
      tasto={<><IconaNova nome={'cuffie'} misura={18}/><span className={'nova-tasto-testo'}>{t('Aiuto')}</span></>}>
      {aiuto.map((p) => voceTendina(p.percorso, <><IconaNova nome={ICONA_AIUTO[p.chiave] || 'documento'} misura={18}/>{p.titolo}</>, undefined, p.percorso))}
    </TendinaTestata>
  );
}

/**
 * «Account» a destra in testata, per chi e' dentro: in cima il nome, poi le
 * voci della colonna del conto (vociColonnaConto), con le stesse icone a
 * linea, gli stessi nomi e lo stesso ordine: Profilo, Movimenti, Cassa,
 * Sicurezza, Gioco responsabile; poi le voci della rete (sotto la scritta
 * «Rete», solo a chi ne ha almeno una).
 */
function AccountInTestata({nome}) {
  const {t} = useTranslation();
  const conto = vociColonnaConto(t);
  const rete = vociDellaRete(t);
  const iniziale = (nome[0] || '?').toUpperCase();
  return (
    <TendinaTestata nome={t('Account')} classe={'nova-account nova-solo-computer'}
      tasto={<><span className={'nova-avatar'} aria-hidden={'true'}>{iniziale}</span><span className={'nova-tasto-testo'}>{t('Account')}</span></>}>
      {nome && (
        <div className={'nova-account-chi'}>
          <span className={'nova-avatar'} aria-hidden={'true'}>{iniziale}</span>
          <span><b>{nome}</b><small>{t('Il mio account')}</small></span>
        </div>
      )}
      {conto.map((a) => voceTendina(a.to, <><IconaNova nome={a.icona} misura={18}/>{a.testo}</>, undefined, a.to, a.oro))}
      {rete.length > 0 && <p className={'nova-etichetta nova-tendina-etichetta'}>{t('Rete')}</p>}
      {rete.map((a) => voceTendina(a.to, <><IconaNova nome={a.icona} misura={18}/>{a.testo}</>, undefined, a.to))}
    </TendinaTestata>
  );
}

/**
 * LA LINGUA IN TESTATA (modulo Testata › Lingua accanto a Esci, acceso di
 * serie): un tasto piccolo con bandierina e sigla in fondo a destra, che
 * apre la tendina con le lingue della skin, ognuna col suo nome scritto
 * nella lingua stessa. Con una lingua sola non c'e': niente da scegliere.
 * La scelta e' la stessa della tendina nel piede (preferenze.js).
 */
function LinguaInTestata({classe}) {
  const {t} = useTranslation();
  const lingue = lingueDisponibili();
  const corrente = lingua();
  if (!testata().linguaInTestata || lingue.length < 2) return null;
  const bandiera = (codice, nome) => <Bandiera categoria={{paese: paeseDellaLingua(codice), name: nome}} className={'nova-bandierina'}/>;
  return (
    <TendinaTestata nome={t('Lingua')} classe={'nova-lingua-testata' + (classe ? ' ' + classe : '')} chiudiAlClic
      tasto={<>{bandiera(corrente, corrente)}<span className={'nova-lingua-sigla'}>{corrente.toUpperCase()}</span></>}>
      {lingue.map((l) => (
        <button key={l.codice} type={'button'} lang={l.codice} aria-pressed={l.codice === corrente}
          className={'nova-nav-sotto' + (l.codice === corrente ? ' active' : '')} onClick={() => impostaLingua(l.codice)}>
          {bandiera(l.codice, l.nome)}<span>{l.nome}</span><small>{l.codice.toUpperCase()}</small>
        </button>
      ))}
    </TendinaTestata>
  );
}

/**
 * Una voce della testata con la tendina sotto: si apre al passaggio del mouse
 * (CSS) e al tocco (per chi non ha il mouse); si chiude cambiando pagina, con
 * Esc, o toccando fuori. Con `capo` (il collegamento della sezione) il tocco
 * apre solo dalla freccina accanto; senza, la voce stessa e' il tasto («Altro»),
 * con `tasto` come contenuto (Aiuto e Account: icona e scritta) e `nome` per chi
 * non vede. Con `chiudiAlClic` si chiude anche scegliendo una voce che non
 * cambia pagina (la lingua). Con `vaiA` la voce e' un collegamento (Aiuto): il
 * clic porta li', la tendina si apre al passaggio del mouse; `acceso` la segna
 * come pagina aperta.
 */
function TendinaTestata({capo, nome, tasto, classe, chiudiAlClic, vaiA, acceso, children}) {
  const {t} = useTranslation();
  const posizione = useLocation();
  const [aperta, setAperta] = React.useState(false);
  const scatola = React.useRef(null);
  /* Cambiando pagina si chiude, e la voce cliccata perde il fuoco: col fuoco
     dentro (:focus-within) la tendina restava aperta sulla pagina nuova. */
  React.useEffect(() => {
    setAperta(false);
    const dentro = scatola.current && document.activeElement && scatola.current.contains(document.activeElement);
    if (dentro) document.activeElement.blur();
  }, [posizione.pathname, posizione.search]);
  React.useEffect(() => {
    if (!aperta) return undefined;
    const fuori = (e) => { if (scatola.current && !scatola.current.contains(e.target)) setAperta(false); };
    const esc = (e) => { if (e.key === 'Escape') setAperta(false); };
    document.addEventListener('pointerdown', fuori);
    document.addEventListener('keydown', esc);
    return () => { document.removeEventListener('pointerdown', fuori); document.removeEventListener('keydown', esc); };
  }, [aperta]);
  return (
    <div className={'nova-nav-tendina' + (classe ? ' ' + classe : '') + (aperta ? ' aperta' : '')} ref={scatola}>
      <div className={'nova-nav-capo'}>
        {capo}
        {capo ? (
          <button type={'button'} className={'nova-nav-apri'} aria-expanded={aperta} aria-label={t('Apri {{nome}}', {nome})}
            onClick={() => setAperta((v) => !v)}>▾</button>
        ) : vaiA ? (
          <NavLink to={vaiA} className={'nova-nav-voce nova-nav-tasto' + (acceso ? ' active' : '')} aria-label={tasto ? nome : undefined}>
            {tasto || nome}<span className={'nova-nav-freccia'} aria-hidden={'true'}>▾</span>
          </NavLink>
        ) : (
          <button type={'button'} className={'nova-nav-voce nova-nav-tasto'} aria-expanded={aperta}
            aria-label={tasto ? nome : undefined} onClick={() => setAperta((v) => !v)}>
            {tasto || nome}<span className={'nova-nav-freccia'} aria-hidden={'true'}>▾</span>
          </button>
        )}
      </div>
      <div className={'nova-nav-pannello'}
        onClick={chiudiAlClic ? (e) => { if (e.target.closest('button')) { setAperta(false); if (document.activeElement) document.activeElement.blur(); } } : undefined}>
        {children}
      </div>
    </div>
  );
}

/** L'occhio del saldo: aperto = la cifra si vede, sbarrato = censurata. */
function Occhio({aperto}) {
  return (
    <svg width={'18'} height={'18'} viewBox={'0 0 24 24'} fill={'none'} stroke={'currentColor'} strokeWidth={'2'}
      strokeLinecap={'round'} strokeLinejoin={'round'} aria-hidden={'true'}>
      <path d={'M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z'}/>
      <circle cx={'12'} cy={'12'} r={'3'}/>
      {!aperto && <line x1={'3'} y1={'3'} x2={'21'} y2={'21'}/>}
    </svg>
  );
}

/** La lente della casella di ricerca. */
function Lente() {
  return (
    <svg width={'16'} height={'16'} viewBox={'0 0 24 24'} fill={'none'} stroke={'currentColor'} strokeWidth={'2.2'}
      strokeLinecap={'round'} strokeLinejoin={'round'} aria-hidden={'true'}>
      <circle cx={'11'} cy={'11'} r={'7'}/>
      <line x1={'16.5'} y1={'16.5'} x2={'21'} y2={'21'}/>
    </svg>
  );
}
